import { Shield, Users, LayoutDashboard, Receipt } from "lucide-react";
import type React from "react";
import { useState } from "react";
import Logout from "../../../merchant_dashboard/components/sidebar/Logout";
import { NavLink } from "react-router-dom";
import AccountProfile from "../../../merchant_dashboard/components/navigation/AccountProfile";
import HeaderLogo from "../../../merchant_dashboard/components/navigation/HeaderLogo";

interface SidebarProps {
  sidebarOpen: boolean;
  toggleSidebar: () => void;
  userName?: string;
  userEmail?: string;
}

const Sidebar: React.FC<SidebarProps> = ({ sidebarOpen, toggleSidebar }) => {
  const [activeLink, setActiveLink] = useState("/admin/dashboard");

  const handleLinkClick = (path: string) => {
    setActiveLink(path);
  };

  return (
    <div
      className={`fixed lg:relative bg-white z-30 h-full text-gray-800 shadow-lg transition-all duration-300 ease-in-out flex flex-col rounded-r-lg ${
        sidebarOpen ? "w-72 left-0" : "-left-72 lg:left-0 w-0 lg:w-72"
      }`}
    >
      {/* Header with logo */}
      <HeaderLogo toggleSidebar={toggleSidebar} />

      {/* Account Profile Section */}
      <AccountProfile />

      {/* Navigation */}
      <nav className="flex-1 py-4">
        <div className="mb-6">
          <p className="px-6 text-xs uppercase font-semibold text-gray-500 mb-2">
            Main Menu
          </p>

          <NavLink
            to="/admin/dashboard"
            end
            className={({ isActive }) =>
              `flex items-center px-6 py-3 text-sm font-medium transition-colors duration-200 hover:bg-gray-50 ${
                isActive
                  ? "bg-blue-50 text-blue-600 border-r-2 border-blue-600"
                  : "text-gray-700 hover:text-gray-900"
              }`
            }
            onClick={() => handleLinkClick("/admin/dashboard")}
          >
            <div className="flex items-center">
              <div className="p-1.5 rounded-full mr-3">
                <LayoutDashboard size={18} className="text-current" />
              </div>
              <span>Dashboard</span>
            </div>
          </NavLink>

          <NavLink
            to="/admin/dashboard/role-management"
            className={({ isActive }) =>
              `flex items-center px-6 py-3 text-sm font-medium transition-colors duration-200 hover:bg-gray-50 ${
                isActive
                  ? "bg-blue-50 text-blue-600 border-r-2 border-blue-600"
                  : "text-gray-700 hover:text-gray-900"
              }`
            }
            onClick={() => handleLinkClick("/admin/dashboard/role-management")}
          >
            <div className="flex items-center">
              <div className="p-1.5 rounded-full mr-3">
                <Shield size={18} className="text-current" />
              </div>
              <span>Role Management</span>
            </div>
          </NavLink>

          <NavLink
            to="/admin/dashboard/profile-admin"
            className={({ isActive }) =>
              `flex items-center px-6 py-3 text-sm font-medium transition-colors duration-200 hover:bg-gray-50 ${
                isActive
                  ? "bg-blue-50 text-blue-600 border-r-2 border-blue-600"
                  : "text-gray-700 hover:text-gray-900"
              }`
            }
            onClick={() => handleLinkClick("/admin/dashboard/profile-admin")}
          >
            <div className="flex items-center">
              <div className="p-1.5 rounded-full mr-3">
                <Users size={18} className="text-current" />
              </div>
              <span>Profile Admins</span>
            </div>
          </NavLink>

          <NavLink
            to="/admin/dashboard/transactions"
            className={({ isActive }) =>
              `flex items-center px-6 py-3 text-sm font-medium transition-colors duration-200 hover:bg-gray-50 ${
                isActive
                  ? "bg-blue-50 text-blue-600 border-r-2 border-blue-600"
                  : "text-gray-700 hover:text-gray-900"
              }`
            }
            onClick={() => handleLinkClick("/admin/dashboard/transactions")}
          >
            <div className="flex items-center">
              <div className="p-1.5 rounded-full mr-3">
                <Receipt size={18} className="text-current" />
              </div>
              <span>Transactions</span>
            </div>
          </NavLink>
        </div>
      </nav>

      {/* Logout Button */}
      <Logout />
    </div>
  );
};

export default Sidebar;
